var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",class:_vm.classCustom},[(_vm.label)?_c('label',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('label',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }